<template>
    <div>
        <my-form
        class="form-page"
        v-model="form"
        readonly
        table
        label-width="160px">

            <el-form-item
            label="专家名称">
                {{form.zjname}}
            </el-form-item>
            <el-form-item
            label="工作单位">
                {{form.e_gzdw}}
            </el-form-item>

            <el-form-item
            label="任评标委员会">
                {{form.e_pwhzw}}
            </el-form-item>
            <el-form-item
            label="业务水平"
            >
                {{form.ywsp}}
            </el-form-item>
              
            <el-form-item
            label="优点"
            >
                {{form.youdiantext}}
            </el-form-item>
            <el-form-item
            label="不足"
            >
                {{form.buzutext}}
            </el-form-item>

            <el-form-item
            label="评标过程中违规违纪行为"
            >
                {{form.wjxwtext}}
            </el-form-item>
            <el-form-item
            label="表现评价打分"
            >
                {{form.fenshu}}
            </el-form-item>

            <el-form-item
            label="表现评价文字表述"
            class="table-full-row">
                {{form.pjxs}}
            </el-form-item>
        </my-form>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'
import DIALOG_FORM_PAGE_MIXIN from '@views/mixins/dialog-form-page'
import MODEL_MIXIN from '@/mixins/model'

export default {
    mixins: [ MODEL_MIXIN, FORM_PAGE_MIXIN, DIALOG_FORM_PAGE_MIXIN ],
    components: { },
    props: {
        youdian: {
            type: Array,
            default: () => []
        },
        buzu: {
            type: Array,
            default: () => []
        },
        wjxw: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({

    }),
    computed: {
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', value);
            }
        }
    },
    methods: {

    },
    created() {
      
        
        // this.jspInit(`${this.getGetters('bidUrl')}/newpingbiao/pbwyh/zjpj.json`, 
        //     {
        //         pwhcycode:this.getQuery('pwhcycode'),
        //     }
        //  , data => {
        //      console.log(data.pjmodel)
        // });
    }
}
</script>

<style scoped lang="scss">

</style>
